
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate/[slug]",
      function () {
        return require("private-next-pages/corporate/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate/[slug]"])
      });
    }
  